import { render, staticRenderFns } from "./printCFPurInquiry.vue?vue&type=template&id=04a79d9a&scoped=true&"
import script from "./printCFPurInquiry.vue?vue&type=script&lang=js&"
export * from "./printCFPurInquiry.vue?vue&type=script&lang=js&"
import style0 from "./printCFPurInquiry.vue?vue&type=style&index=0&id=04a79d9a&lang=less&scoped=true&"
import style1 from "./printCFPurInquiry.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a79d9a",
  null
  
)

component.options.__file = "printCFPurInquiry.vue"
export default component.exports